export const environment = {
  production: true,
  extension: false,
  docker: false,
  nativescript: false,
  VERSION: require("../../package.json").version
};
